import { useEffect } from "react";

function Centralisation() {
  useEffect(() => {
    window.location.replace("https://cleezoclass.com/Admission/");
  }, []);

  return <h2>Opening Admission...</h2>;
}

export default Centralisation;